import React from 'react';
import I18n from 'i18n-js';

import appleBadgeDe from '../../../images/app-store-badges/apple-app-store-de.svg';
import googleBadgeDe from '../../../images/app-store-badges/google-play-store-de.svg';
import appleBadgeEn from '../../../images/app-store-badges/apple-app-store-en.svg';
import googleBadgeEn from '../../../images/app-store-badges/google-play-store-en.svg';
import appleBadgeEs from '../../../images/app-store-badges/apple-app-store-es.svg';
import googleBadgeEs from '../../../images/app-store-badges/google-play-store-es.svg';
import appleBadgeFr from '../../../images/app-store-badges/apple-app-store-fr.svg';
import googleBadgeFr from '../../../images/app-store-badges/google-play-store-fr.svg';
import appleBadgeIt from '../../../images/app-store-badges/apple-app-store-it.svg';
import googleBadgeIt from '../../../images/app-store-badges/google-play-store-it.svg';
import appleBadgeJa from '../../../images/app-store-badges/apple-app-store-ja.svg';
import googleBadgeJa from '../../../images/app-store-badges/google-play-store-ja.svg';

const LOCALE_TO_APPLE_BADGE = {
  de: appleBadgeDe,
  en: appleBadgeEn,
  es: appleBadgeEs,
  fr: appleBadgeFr,
  it: appleBadgeIt,
  ja: appleBadgeJa,
};

const LOCALE_TO_GOOGLE_BADGE = {
  de: googleBadgeDe,
  en: googleBadgeEn,
  es: googleBadgeEs,
  fr: googleBadgeFr,
  it: googleBadgeIt,
  ja: googleBadgeJa,
};

interface IProps {
  userLocale: string;
  linkLocation: 'footer' | 'homepage'
}

const links = {
  homepage: {
    ios: 'https://reverb.app.link/homepageios',
    android: 'https://reverb.app.link/homepageandroid',
  },
  footer: {
    ios: 'https://reverb.app.link/sitefooterios',
    android: 'https://reverb.app.link/sitefooterandroid',
  },
};

export function AppleAppStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.ios;
  const appleImage = LOCALE_TO_APPLE_BADGE[props.userLocale.slice(0, 2)] || appleBadgeEn;

  return (
    <a
      className="d-inline-block"
      href={link}
    >
      <img
        className="d-block width-100"
        src={appleImage}
        alt={I18n.t('discovery.getTheApp.iosAlt')}
      />
    </a>
  );
}

export function GooglePlayStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.android;
  const googleImage = LOCALE_TO_GOOGLE_BADGE[props.userLocale.slice(0, 2)] || googleBadgeEn;

  return (
    <a
      className="d-inline-block"
      href={link}
    >
      <img
        className="d-block width-100"
        src={googleImage}
        alt={I18n.t('discovery.getTheApp.androidAlt')}
      />
    </a>
  );
}
